import { inject, Injectable } from '@angular/core';
import { UserLogin } from '@fsf/types';
import { WA_LOCAL_STORAGE } from '@ng-web-apis/common';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  readonly #USER_KEY = 'user_data';
  readonly #storage = inject(WA_LOCAL_STORAGE);

  setUser(userData: UserLogin) {
    this.#storage.setItem(this.#USER_KEY, JSON.stringify(userData));
  }
  getUser(): UserLogin | null {
    const userData = this.#storage.getItem(this.#USER_KEY);
    return userData ? JSON.parse(userData) : null;
  }
  clearUser() {
    this.#storage.removeItem(this.#USER_KEY);
  }
}

// {
//     "data": {
//         "id": "1",
//         "name": "Development",
//         "email": "development@freesixtyfive.de",
//         "firstName": null,
//         "lastName": null,
//         "companyName": null,
//         "permissions": [],
//         "roles": []
//     },
//     "meta": {
//         "responderVersion": "v1"
//     }
// }
// https://fe-dev.eliso.fsf.tools/locations/list
// development@freesixtyfive.de
// 1q2w3e
